/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "73cf49961f271ef070225f49e817f20fdeaf9176";
